import { HOST } from "../constants/HostConstants";

export const promotionReject = async (promotion_id, user_id, reason) => {
  try {
    const response = await fetch(`${HOST}/api/promotion/reject`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        promotion_id,
        user_id,
        reason,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Failed to reject profile promotion");
    }

    return await response.json();
  } catch (error) {
    console.error("Error rejecting profile promotion:", error);
    throw error;
  }
};
